import type { ReactElement } from 'react';
import type { FieldDefinition, FieldValue } from '@gr/core/content/entities/fields';
import { FieldInput } from '../FieldInput/FieldInput';
import type { ReferenceLookup } from '../model/reference-search';

export interface FieldValuesInputProps {
  fields: readonly FieldDefinition[];
  values: Readonly<Record<string, FieldValue>>;
  /** Тексты ошибок по ключу поля. */
  errors: Readonly<Record<string, string | null>>;
  references: ReferenceLookup;
  disabled?: boolean;
  onChange(key: string, value: FieldValue): void;
}

/** Значения пользовательских полей записи (ENT-UC-5) или поста (POST-UC-2). */
export function FieldValuesInput({ fields, values, errors, references, disabled, onChange }: FieldValuesInputProps): ReactElement {
  return (
    <>
      {fields.map((field) => (
        <FieldInput
          key={field.key}
          field={field}
          value={values[field.key]}
          error={errors[field.key] ?? null}
          disabled={disabled}
          references={references}
          onChange={(value) => onChange(field.key, value)}
        />
      ))}
    </>
  );
}
